import React from 'react';
import { useSearchParams } from 'react-router-dom';

import ServicesTab from '../components/ServicesTab';
import WaypointsTab from '../components/WaypointsTab';
import { ServiceHistoryTab } from '../types';

const ServiceHistoryPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTabParam = searchParams.get('tab') as ServiceHistoryTab | null;
  const activeTab = activeTabParam ?? ServiceHistoryTab.Waypoints;

  const handleTabChange = (value: ServiceHistoryTab) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="flex flex-col h-full gap-5 text-sm pt-5 lg:px-8 md:px-6 md:text-base">
      {activeTab === ServiceHistoryTab.Waypoints ? (
        <WaypointsTab activeTab={activeTab} handleTabChange={handleTabChange} />
      ) : (
        <ServicesTab activeTab={activeTab} handleTabChange={handleTabChange} />
      )}
    </div>
  );
};

export default ServiceHistoryPage;
